import { NotifyHelper } from "../../../helpers/toast";
import { eGiaiDoanActionsObj } from "../../action-types/ke-hoach/IGiaiDoanActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const giaiDoanActions = {
    ...generateActions(eGiaiDoanActionsObj, "GIAI_DOAN"),
    ...generateActionForKey(eGiaiDoanActionsObj, "GIAI_DOAN", "SAVE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eGiaiDoanActionsObj, "GIAI_DOAN", "DELETE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eGiaiDoanActionsObj, "GIAI_DOAN", "SAVE_ERROR", (m) => NotifyHelper.Error(m)),
    ...generateActionForKey(eGiaiDoanActionsObj, "GIAI_DOAN", "DELETE_ERROR", (m) => NotifyHelper.Error(m)),
};
